export default __webpack_public_path__ + "static/media/icon.d715a803.svg";